import { render, staticRenderFns } from "./AddOurFacility.vue?vue&type=template&id=50ec27d5&scoped=true&"
import script from "./AddOurFacility.vue?vue&type=script&lang=js&"
export * from "./AddOurFacility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec27d5",
  null
  
)

export default component.exports